export default {
    methods: {
        scrollTo(id) {
            if ('HomeBranding' !== this.$route.name) {
                return this.$router.push({ name: 'HomeBranding', hash: `#${id}` })
            }

            const element = document.querySelector(`#${id}`)
            const offset = 120;
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
                delay: 4
            });
        }
    }
}